export default {
  header: 'Order Summary',
  buttons: {
    checkout: 'Checkout',
    continue: 'Continue',
    add_products: '+ Add products',
    add_items: '+ Add more items',
    menu: 'Menu',
  },
  empty_order_basket: {
    description: 'Your basket is empty <br/> Add items to get started',
  },
  promo_code_banner: {
    single_use: '{{discount}} discount - {{code}}',
    multi_use: '{{discount}} discount on {{count}} orders - {{code}}',
    redeem: 'REDEEM',
    redeemed: 'REDEEMED',
  },
  upsell: {
    title: 'People also order',
  },
  rewards: {
    title: 'Pay with points & save when you’re a V.I.P member.',
  },
};
